import Head from 'next/head';
import { generateNextSeo } from 'next-seo/pages';

/* Components */
import { getLayout } from '@components/PageLayouts/Layout/Standard';
import IframeView from '@components/IframeView';

/* Exportable Iframe */
export const PrivacyIframe = () => (
  <IframeView callerPageName="privacy-policy" src={`${process.env.NEXT_PUBLIC_WEBFLOW_CONTENTS_URL}privacy-policy`} />
);

function PrivacyPage(props: any) {
  return (
    <>
      <Head>{generateNextSeo({ title: 'Privacy Policy' })}</Head>
      <PrivacyIframe />
    </>
  );
}

PrivacyPage.pageAttributes = { page: 'privacyPolicy' };
PrivacyPage.Layout = getLayout({ promo: false, footer: true });

export default PrivacyPage;
